import { get } from '@dark-portal/react-infrastructure';
import { getIdentityConfig } from '../config';
import { MeResponse } from '../store/state';
import { withAuthGuard } from './withAuthGuard';

export const meRequest = async (): Promise<MeResponse> => {
  const { request } = get<undefined, MeResponse>({
    url: `${getIdentityConfig().apiUrl}/identity/auth/me`,
  });

  const response = await request;

  return response.data;
};

export const guardedMeRequest = async (): Promise<MeResponse> => {
  const { request } = withAuthGuard(get<undefined, MeResponse>)({
    url: `${getIdentityConfig().apiUrl}/identity/auth/me`,
  });

  const response = await request;

  return response.data;
};
